import { _WorkCategory } from "../interfaces/responseModels/_WorkCategory";

export class WorkCategory extends _WorkCategory{

    constructor(obj){
        super();
        Object.assign(this, obj);
    }
}